import { supabase } from '@/lib/supabase'

function ensureFeatureObject(features: any): any {
  if (Array.isArray(features)) return { list: features }
  if (features && typeof features === 'object') return { ...features }
  return {}
}

export async function updatePlanMeta(id: string, metaPatch: Record<string, any>): Promise<void> {
  const { data, error } = await supabase.from('plans').select('features').eq('id', id).maybeSingle()
  if (error) throw error
  const fx = ensureFeatureObject((data as any)?.features)
  const next = { ...fx, ...metaPatch }
  const { error: upErr } = await supabase.from('plans').update({ features: next }).eq('id', id)
  if (upErr) throw upErr
}

export async function bulkUpdatePlanMeta(updates: Array<{ id: string; meta: Record<string, any> }>): Promise<void> {
  for (const u of updates) {
    await updatePlanMeta(u.id, u.meta)
  }
}

